import { render, staticRenderFns } from "./MaxxFormFieldsDisplay.vue?vue&type=template&id=3201b0d0&scoped=true&"
import script from "./MaxxFormFieldsDisplay.vue?vue&type=script&lang=js&"
export * from "./MaxxFormFieldsDisplay.vue?vue&type=script&lang=js&"
import style0 from "./MaxxFormFieldsDisplay.vue?vue&type=style&index=0&id=3201b0d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3201b0d0",
  null
  
)

export default component.exports